<template>
    <div class="commerical-dashboard position-relative">
        <CButton type="button" to="/campaign-register" color="primary" class="d-flex position-absolute back-btn">← Back</CButton>
        <CTabs :activeTab="tabIndex" @update:activeTab="handleTabChange">
            <CTab title="Campaign Performance">
                <CampaignPerformance v-if="tabIndex === 0"/>
            </CTab>
            <CTab title="Emails">
                <Emails v-if="tabIndex === 1"/>
            </CTab>
            <CTab title="Social Media">
                <SocialMedia v-if="tabIndex === 2"/>
            </CTab>
            <CTab title="Audience Insight">
                <Audience v-if="tabIndex === 3"/>
            </CTab>
            <CTab title="Campaign ROI">
                <CampaignROI v-if="tabIndex === 4"/>
            </CTab>
        </CTabs>
    </div>
</template>
<script>
import CampaignPerformance from "@/containers/CommericalDashboard/CampaignPerformance.vue";
import Emails from "@/containers/CommericalDashboard/Emails.vue";
import SocialMedia from "@/containers/CommericalDashboard/SocialMedia.vue";
import Audience from "@/containers/CommericalDashboard/Audience.vue";
import CampaignROI from "@/containers/CommericalDashboard/CampaignROI.vue";
export default {
    name: "CommericalDashboard",
    components: {
        CampaignPerformance,
        Emails,
        SocialMedia,
        Audience,
        CampaignROI
    },
    data() {
        return {
            tabIndex: 0
        }
    },
    methods: {
        handleTabChange(index) {
            this.tabIndex = index;
        }
    }
}
</script>
<style scoped>
.back-btn {
    right: 10px;
}
</style>